import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=23f5cd4e&scoped=true"
import script from "./documentList.vue?vue&type=script&lang=js"
export * from "./documentList.vue?vue&type=script&lang=js"
import style0 from "./documentList.vue?vue&type=style&index=0&id=23f5cd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5cd4e",
  null
  
)

export default component.exports